export const Constants = {};

export const pieChartColors = [
  "#E45C1D",
  "#FCED23",
  "#07B151",
  "#2FBBB3",
  "#2357BC",
  "#4C489B",
  "#733B97",
  "#AF3A94",
  "#D52127",
  "#F36621",
  "#F6851E",
  "#E45C1D",
];

export const Colors = {
  chaosBlack: "#101010",
  white: "#FFFFFF",
  black: "#000000",
  rockBlue: "#90a0b7",
  midnight: "#192a3e",
  whiteSmoke: "#f3f3f3",
  eclipse: "#383636",
  magnolia: "#F2ECFF",
  mischka: "#9da3bb",
  mediumLightBlue: "#AFB1B6",
  gainsboro: "#d9d9d9",
  gulfBlue: "#2e3a59",
  solitude: "#eff0f4",
  aliceBlue: "#f7f8fa",
  eastBay: "#505470",
  midnightExpress: "#232638",
  cloudyGrey: "#aeb4cf",
  purplishGrey: "#5b5f7b",
  solidRed: "#FF0000",
  blackSqueeze: "#FCFDFE",
  mischkaApprox: "#CDCFD9",
  blackOpacity: "rgba(0, 0, 0, 0.8)",
  coralRedApprox: "#FF333F",
  red: "#FF0000",
  athensGrey: "#e4e6ee",
  autumnFog: "#BBBBBB",
  electricBlue: "#5b5f7b",
  citrus: "#00CB9A",
  furiousTomato: "#F84E59",
  emperorApprox: "#525252",
  mineShaft: "#262626",
  comet: "#5B5F7B",
  athensGray: "#E4E6EE",
  logan: "#AEB4CF",
  tangerine: "#FF9533",
  lightTangerine: "rgba(255, 149, 51, 0.2)",
  blackRussian: "#14142B",
  secondaryBlack: "#333333",
  santasGray: "#9FA2B4",
  coastlineBlue: "#2845FF",
  silver: "#CCCCCC",
  mainGreen: "#57D78A",
  hippy: "#EA7D83",
  ultraMarineBlue: "#3366FF",
  lightUltraMarineBlue: "#3366FF32",
  appleGreen: "#57B379",
  lightAppleGreen: "#57B37932",
  pureRed: "#FF333F",
  lightPureRed: "#FF333F32",
  fogWhite: "#F1F2F3",
  linkBlue: "#005CFF",
  appleRed: "#EA3323",
  alto: "#e0e0e0",
  aluminium: "#A9ABB0",
  dustyGray: "#999999",
  zirconApprox: "#F5F8FF",
  selagoApprox: "#EFF2FC",
  dustyGrayApprox: "#999999",
  saffronApprox: "#F4C031",
  laPalma: "#26A212",
  aqua: "#33CCCC",
  altoApprox: "#d4d4d4",
  ticketColorBlue: "#2A5CA3",
};

export const Text = {
  loginHeader: "Login to Admin Panel",
  loginSubHeader: "Enter your email and password below",
  loginEmailPlaceholder: "Enter email",
  loginPasswordPlaceholder: "Enter password",
  loginEnterEmail: "Please enter the email id",
  loginEnterPassword: "Please enter the password",
  loginInvalidEmail: "Invalid email id",
  loginButtonLabel: "Login",
  welcomeText: "Welcome",
  dashboardText: "Dashboard",
  subjectEnterText: "Please enter the title",
  messageEnterText: "Please enter the message",
  checkboxSub:
    "When you check this box, a notification will be sent to all users immediately after the events are created.",
  offlineMessage: "You're offline now",
  internetDisconnected: "Oops! Internet is disconnected.",
  physicalCardHeader: "Physical Card",
  disputeHeader: "Dispute",
  disputeHistoryHeader: "Dispute History",
  downloadButtonText: "Download",
  disputeResolutionConfirm: "Confirm Dispute Resolution",
  cancelButton: "Cancel",
  yesButton: "Yes",
  somethingWentWrong: "Something went wrong.",
  okButton: "Ok",
  yachtClubRegistrationHeader: "Yacht Club Registration",
  yachtClubRegistrationDetailsHeader: "Yacht Club Registration Details",
  yachtRegistrationHistoryHeader: "Yacht Registration History",
  yachtRegistrationHistoryDetails: "Yacht Club Registration History Details",
  parkingLayout: "Parking Layout",
  berthTariff: "Berth Tariff",
  addBerthTariff: "Add New Tariff",
  enterCheckNum: "Enter Cheque Number",
  enterAmount: "Enter Amount",
  paymentReceived: "Payment received",
  payementPending: "Payment Pending",
  paymentCompleted: "Payment Completed",
};

export const MERCHANT_ROLES = [
  {
    label: "Choose role of the merchant",
    value: "",
  },
  {
    label: "Outlet Merchant",
    value: 1,
  },
  {
    label: "Security Personal",
    value: 2,
  },
];

export const MERCHANT_STATUS = [
  {
    label: "Status",
    value: "",
  },
  {
    label: "Active",
    value: 1,
  },
  {
    label: "Inactive",
    value: 0,
  },
];

export const OUTLET_TYPES_PARK = [
  {
    label: "Parks",
    key: "parks",
    value: "5",
  },
];
export const OUTLET_TYPES = [
  {
    label: "Select Outlet Type",
    key: "select",
    value: "",
  },
  {
    label: "Restaurants",
    key: "restaurants",
    value: "1",
  },
  {
    label: "Top Attractions",
    key: "top_attractives",
    value: "2",
  },
  {
    label: "High End District",
    key: "high_end_district",
    value: "3",
  },
  {
    label: "Standard Restaurants",
    key: "standard_restaurants",
    value: "4",
  },
  {
    label: "Parks",
    key: "parks",
    value: "5",
  },
  {
    label: "Coffee",
    key: "coffee",
    value: "6",
  },
  {
    label: "Dining",
    key: "dining",
    value: "7",
  },
];

export const CATEGORY = [
  {
    label: "Select Category",
    value: "none",
  },
  {
    label: "Home",
    value: "home",
  },
  {
    label: "Events",
    value: "events",
  },
  {
    label: "Parks",
    value: "parks",
  },
  {
    label: "Restaurants",
    value: "restaurants",
  },
];

export const DAYS_OF_WEEK = [
  {
    day: "Monday",
    key: "mon",
  },
  {
    day: "Tuesday",
    key: "tue",
  },
  {
    day: "Wednesday",
    key: "wed",
  },
  {
    day: "Thursday",
    key: "thu",
  },
  {
    day: "Friday",
    key: "fri",
  },
  {
    day: "Saturday",
    key: "sat",
  },
  {
    day: "Sunday",
    key: "sun",
  },
];

export const pieChartTabs = [
  { value: 1, label: "Today" },
  { value: 2, label: "Yesterday" },
  { value: 3, label: "This Week" },
];

export const pieChartLabels = [
  { index: 0, label: "Rossopomodoro" },
  { index: 1, label: "Pura Vida" },
  { index: 2, label: "Moka Cafe" },
  { index: 3, label: "Em Sherif" },
  { index: 4, label: "Nammos" },
  { index: 5, label: "LPM" },
  { index: 6, label: "Billionaire" },
  { index: 7, label: "Beefbar" },
  { index: 8, label: "Karaki" },
  { index: 9, label: "Zuma" },
  { index: 10, label: "Carbon" },
  { index: 11, label: "Beefbar" },
];

export const PAYMENT_MODES = [
  {
    label: "Select",
    value: "none",
  },
  {
    label: "Cash",
    value: "cash",
  },
  {
    label: "Cheque",
    value: "cheque",
  },
  {
    label: "Online",
    value: "online",
  },
];

export const PAYMENT_MODES_POPUP = [
  {
    label: "Select",
    value: "",
  },
  {
    label: "Cash",
    value: "cash",
  },
  {
    label: "Cheque",
    value: "cheque",
  },
];

export const NEW_PARK_VISIT_TIME_INIT = {
  mon: {
    start: "",
    end: "",
  },
  tue: {
    start: "",
    end: "",
  },
  wed: {
    start: "",
    end: "",
  },
  thu: {
    start: "",
    end: "",
  },
  fri: {
    start: "",
    end: "",
  },
  sat: {
    start: "",
    end: "",
  },
  sun: {
    start: "",
    end: "",
  },
};

export const ACCESS_RIGHTS = [
  {
    key: 1,
    value: "Admin",
  },
  {
    key: 2,
    value: "Keeper",
  },
  {
    key: 3,
    value: "Merchant Staff",
  },
  {
    key: 4,
    value: "Merchant Supervisor",
  },
  {
    key: 5,
    value: "Park Keeper",
  },
  {
    key: 6,
    value: "LWW Ticket Admin",
  },
];

export const EVENT_DEEP_LINK_TYPE = [
  {
    label: "Parks",
    value: "parks",
  },
  {
    label: "Events",
    value: "events",
  },
];

export const WEEK_INDEX = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

export const AMD_RENEWAL_PERIOD_OPTIONS = [
  {
    label: "Select Period of Renewal After Membership Expiry ",
    value: "",
  },
  { label: "60 Days", value: 60 },
];

export const DYNAMIC_PROMO_TYPES = [
  {
    label: "Select Dynamic Promo Type",
    value: "",
  },
  {
    label: "Dynamic Product Discount",
    value: "dynamicProductDiscount",
  },
  {
    label: "Dynamic Product Price Discount for Employees",
    value: "dynamicProductPriceDiscount",
  },
  { label: "Dynamic Cart Discount", value: "specialDiscount" },
  { label: "Dynamic Promotion", value: "dynamicPromotion" },
];
